import { Routes } from '@angular/router';
import { LoginComponent } from '@adgate/modules/main/components/login-component/login-component';
import { MainFrameComponent } from '@adgate/modules/main/components/main-frame-component/main-frame-component';
import { RouteActivateGuard } from '@adgate/common/guards/route-activate-guard';
import { RouteDeactivateGuard } from '@adgate/common/guards/route-deactivate-guard';
import { DashboardComponent } from '@adgate/modules/main/components/dashboard-component/dashboard-component';
import { TvMainComponent } from '@adgate/modules/tv/components/tv-main-component/tv-main-component';
import { StreamingMainComponent } from '@adgate/modules/streaming/components/streaming-main-component/streaming-main-component';
import { AdminPanelMainComponent } from '@adgate/modules/admin/components/admin-panel-main-component/admin-panel-main-component';
import { ProductionMainComponent } from '@adgate/modules/production/components/production-main-component/production-main-component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: "login" },
  { path: 'login', component: LoginComponent },
  { 
    path: 'main', 
    component: MainFrameComponent, 
    canActivate: [RouteActivateGuard], 
    canDeactivate: [RouteDeactivateGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent, canDeactivate: [RouteDeactivateGuard] },
      { path: 'tv', component: TvMainComponent, canActivate: [RouteActivateGuard], canDeactivate: [RouteDeactivateGuard] },
      { path: 'streaming', component: StreamingMainComponent, canActivate: [RouteActivateGuard], canDeactivate: [RouteDeactivateGuard] },
      { path: 'production', component: ProductionMainComponent, canActivate: [RouteActivateGuard], canDeactivate: [RouteDeactivateGuard] },
      { path: 'admin', component: AdminPanelMainComponent, canActivate: [RouteActivateGuard], canDeactivate: [RouteDeactivateGuard] },
    //   { path: '', pathMatch: 'full', redirectTo: "menu" },
      { path: '**', redirectTo: "main" },
    ]
  },
  { path: '**', redirectTo: "main" },
];
